/** The one piece of firebase/firestore's Timestamp the normalizers need —
 * kept structural so this module stays free of firebase imports. */
interface TimestampLike {
    toDate(): Date;
}

/**
 * Firestore read-boundary coercion, shared by normalizeGateDoc (./gates.ts)
 * and normalizeNotificationDoc (./notifications.ts). bogg ships native
 * Timestamps where design/GATE.md promises RFC3339 strings, and every
 * `new Date(Timestamp)` is Invalid — so both boundaries must coerce.
 *
 * Strings pass through untouched rather than being canonicalized: downstream
 * NaN comparisons then fail open (a junk date never marks a gate card
 * stale/ended), which is deliberate — don't hide a live card.
 */
export function toIso(v: unknown): string | null {
    if (typeof v === 'string') return v;
    if (v != null && typeof (v as TimestampLike).toDate === 'function') {
        // A throwing toDate should be unreachable — Firestore deserializes map
        // fields to plain values, never callables, so this is always a real
        // Timestamp. Caught anyway: this runs inside the bell's onSnapshot map,
        // where an escaping throw kills the subscription and blanks the bell.
        try {
            const d = (v as TimestampLike).toDate();
            return Number.isNaN(d.getTime()) ? null : d.toISOString();
        } catch {
            return null;
        }
    }
    return null;
}
